// extracted by mini-css-extract-plugin
export default {"formInner":"EditForm_formInner__ZuGUb","buttonMargin":"EditForm_buttonMargin__64dMN"};